import { Component } from "preact";
import actions from "../../actions";
import MobileFilter from "./MobileFilter";
import DesktopFilter from "./DesktopFilter";
import { isMobileOnly } from "react-device-detect";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import IconSliders from "../../../common/components/icons/IconSliders";
import IconFilter from "../../../common/components/icons/IconFilter";
import IconTimes from "../../../common/components/icons/IconTimes";
import IconInfoCircle from "../../../common/components/icons/IconInfoCircle";
import { GTM_ID, GA4EVENT} from "../../constants";
import { getDateRange } from "../../helpers/filter/dateRange";
import TimeFilter from "./common/TimeFilter";
import { TIME_FILTERS_VALUES } from "../../constants";
import DownloadFilter from "./common/DownloadFilter";
import IconCogSolid from "../../../common/components/icons/IconCogSolid";

class EventListFilter extends Component {
    constructor(props) {
        super(props);

        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.onChangeCustomFilter = this.onChangeCustomFilter.bind(this);
        this.onChangeFilterDateRange = this.onChangeFilterDateRange.bind(this);
        this.onApplyRange = this.onApplyRange.bind(this);
    }

    componentWillMount() {
        this.props.settings.filter.dateRange = getDateRange(
            this.props.settings.filter,
            this.props.settings.timezoneOffset
        );
        this.props.fetchEventDates();
    }

    onChangeFilter({ time }) {
        var dateRange = getDateRange(
            { time },
            this.props.settings.timezoneOffset
        );
        this.props.changeFilter({ dateRange, time });
    }

    onChangeFilterDateRange({ dateRange }) {
        var time = TIME_FILTERS_VALUES.Custom;
        this.props.changeFilter({ dateRange, time });
    }

    onChangeCustomFilter() {
        var time = TIME_FILTERS_VALUES.Custom;
        var dateRange = this.props.settings.filter.dateRange;
        this.props.changeFilter({ dateRange, time });
    }

    onApplyRange({ dateRange }) {
        var time = this.props.settings.filter.time;
        this.props.changeFilterAndFetch({ dateRange, time });
    }

    render({
        translate,
        config,
        changeShowMobileFilter,
        showMobileFilter,
        toggleModalLegend,
        settings,
        showSuccessMessage,
    }) {
        return (
            <div class="fxs_ecocal_filter">
                {isMobileOnly ? (
                    <div class="fxs_c_header-wrapper">
                        <div class="fxs_c_header-filter-wrapper">
                            {config.showTitleMob && (
                                <h1 class="fxs_sectionTitle_header">
                                    {translate("TitleMob")}
                                </h1>
                            )}
                            <div class="fxs_fRight">
                                <button
                                    type="button"
                                    class="fxs_btn fxs_btn_phantom fxs_c_mobile-filter-trigger fxs_fRight"
                                    data-gtmid={
                                        config.tracking &&
                                        (showMobileFilter
                                            ? GTM_ID.MOBILE_FILTER_CLOSE
                                            : GTM_ID.MOBILE_FILTER_OPEN)
                                    }
                                    data-ga4event-clk-name={ config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                    data-ga4event-element = {
                                        config.tracking &&
                                        (showMobileFilter
                                            ? GA4EVENT.ELEMENTS.MOBILE_FILTER_CLOSE
                                            : GA4EVENT.ELEMENTS.MOBILE_FILTER_OPEN)
                                    }

                                    onClick={() =>
                                        changeShowMobileFilter(
                                            !showMobileFilter
                                        )
                                    }
                                >
                                    <IconFilter />
                                </button>
                                <DownloadFilter
                                    buttonSizeClass="fxs_btn fxs_btn_icon  fxs_btn_legend"
                                    containerClass="fxs_fRight"
                                    buttonType="fxs_btn_phantom"
                                    buttonSize=""
                                />
                                <button
                                    type="button"
                                    class="fxs_btn fxs_btn_icon  fxs_btn_legend"
                                    data-gtmid={
                                        config.tracking &&
                                        GTM_ID.CONFIGURATION_HELP
                                    }
                                    data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                    data-ga4event-element = {config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_HELP}

                                    onClick={toggleModalLegend}
                                >
                                    <IconInfoCircle />
                                </button>

                                <button
                                    type="button"
                                    data-gtmid={
                                        config.tracking &&
                                        GTM_ID.CONFIGURATION_GEAR
                                    }
                                    data-ga4event-clk-name={config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR}
                                    data-ga4event-element = {config.tracking && GA4EVENT.ELEMENTS.CONFIGURATION_GEAR}

                                    onClick={() =>
                                        this.props.openCalendarSettings()
                                    }
                                    class="fxs_btn fxs_btn_phantom fxs_btn_legend"
                                >
                                    <IconCogSolid />
                                </button>
                            </div>
                            <div class="fxs_c_ecocal_filter">
                                {showMobileFilter && <MobileFilter />}
                                <hr class="fxs_divider_wide" />
                            </div>
                        </div>
                        {showSuccessMessage && (
                            <div
                                class="fxs_contextual_alert fxs_alert_success alert alert-dismissible fade in"
                                role="alert"
                            >
                                <p class="fxs_alertText">
                                    {translate("Success_Message")}
                                </p>
                            </div>
                        )}
                        <div class="fxs_c_time_filters_wrapper">
                            {
                                <TimeFilter
                                    time={settings.filter.time}
                                    dateRange={settings.filter.dateRange}
                                    onTimeFilterChanged={(time) =>
                                        this.onChangeFilter({ time })
                                    }
                                    applyFilter={(dateRange) =>
                                        this.onApplyRange({ dateRange })
                                    }
                                    onDateRangeFilterChanged={(dateRange) =>
                                        this.onChangeFilterDateRange({
                                            dateRange,
                                        })
                                    }
                                    onChangeCustomFilter={
                                        this.onChangeCustomFilter
                                    }
                                    getCalendarTimeOptionGtmId={(timeOption) =>
                                        config.tracking &&
                                        GTM_ID.DATEPIKER_OPTION(
                                            timeOption.replace(
                                                "TimeFilter_",
                                                ""
                                            )
                                        )
                                    }
                                    getCalendarTimeOptionGa4Id={(timeOption) =>
                                        config.tracking &&
                                        GA4EVENT.ELEMENTS.DATEPIKER_OPTION(
                                            timeOption.replace(
                                                "TimeFilter_",
                                                ""
                                            )
                                        )
                                    }

                                    getCalendarButtonGtmId={
                                        config.tracking &&
                                        GTM_ID.DATEPIKER_TIMESELECTOR_BUTTON
                                    }
                                    getCalendarButtonGa4Id={
                                        config.tracking &&
                                        GA4EVENT.ELEMENTS.DATEPIKER_TIMESELECTOR_BUTTON
                                    }
                                    getGa4Name={
                                        config.tracking && GA4EVENT.NAMES.FEATURES_CALENDAR
                                    }
                                />
                            }
                        </div>
                        {settings.filter.eventName && (
                            <div class="fxs_c_filter_event_name">
                                <span class="fxs_c_filter_event_name_label">
                                    {translate("ResultsFor")}
                                </span>{" "}
                                <span class="fxs_c_filter_event_name_badge">
                                    <span class="fxs_c_filter_event_name_name">
                                        {settings.filter.eventName}
                                    </span>
                                    <buttom
                                        class="fxs_btn fxs_c_filter_event_name_close_button"
                                        onClick={() => {
                                            this.onChangeFilter({
                                                eventName: null,
                                            });
                                            this.props.fetchEventDates();
                                        }}
                                    >
                                        <IconTimes />
                                    </buttom>
                                </span>
                            </div>
                        )}
                    </div>
                ) : (
                    <div class="fxs_c_header-filter-wrapper">
                        <DesktopFilter
                            onChangeFilter={this.onChangeFilter}
                            onChangeFilterDateRange={
                                this.onChangeFilterDateRange
                            }
                            onChangeCustomFilter={this.onChangeCustomFilter}
                            onApplyRange={this.onApplyRange}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default connectWithTranslations(
    "showMobileFilter, config, settings, notificationsSupported, showSuccessMessage",
    actions
)(EventListFilter);
